import { defineMessages } from 'react-intl'

export const studentScreenMessages = defineMessages({
    // StudentTopBar
    playCapeeshApp: { id: 'student.screen.play.capeesh.app', defaultMessage: 'Play Capeesh App' },
    appOnboarding: { id: 'student.screen.app.onboarding', defaultMessage: 'App onboarding' },
    profile: { id: 'student.screen.profile', defaultMessage: 'Profile' },
    setFullScreen: { id: 'student.screen.set.full.screen', defaultMessage: 'Set Full Screen' },
    signOut: { id: 'student.screen.sign.out', defaultMessage: 'Sign out' },
    openNavigation: { id: 'student.screen.open.navigation', defaultMessage: 'Open navigation' },

    // StudentSidebar
    collapseSidebar: { id: 'student.screen.collapse.sidebar', defaultMessage: 'Collapse sidebar' },
    expandSidebar: { id: 'student.screen.expand.sidebar', defaultMessage: 'Expand sidebar' },
    navigation: { id: 'student.screen.navigation', defaultMessage: 'Navigation' },
    useAppInstead: { id: 'student.screen.use.app.instead', defaultMessage: 'Use app instead' },

    // StudentLesson
    back: { id: 'student.screen.back', defaultMessage: 'Back' },
    loadingLesson: { id: 'student.screen.loading.lesson', defaultMessage: 'Loading lesson...' },
    loadingProgress: { id: 'student.screen.loading.progress', defaultMessage: 'Loading... {progress}%' },
    startLesson: { id: 'student.screen.start.lesson', defaultMessage: 'Start lesson' },

    // MainMenu
    loadingCourses: { id: 'student.screen.loading.courses', defaultMessage: 'Loading your courses...' },
    noCoursesYet: { id: 'student.screen.no.courses.yet', defaultMessage: 'You have no courses' },
    noCoursesDescription: {
        id: 'student.screen.no.courses.description',
        defaultMessage: 'Contact your administrator to get courses assigned to you.',
    },
    myCourses: { id: 'student.screen.my.courses', defaultMessage: 'My Courses' },
    coursesAvailable: {
        id: 'student.screen.courses.available',
        defaultMessage: '{count, plural, one {# course} other {# courses}} available',
    },

    // StudentCourseGroupCard
    courseFallback: { id: 'student.screen.course.fallback', defaultMessage: 'Course' },
    topicCount: {
        id: 'student.screen.topic.count',
        defaultMessage: '{count, plural, one {# topic} other {# topics}}',
    },

    // CourseDetailPanel
    close: { id: 'student.screen.close', defaultMessage: 'Close' },
    yourLanguage: { id: 'student.screen.your.language', defaultMessage: 'Your language' },
    selectLanguage: { id: 'student.screen.select.language', defaultMessage: 'Select language' },
    loadingCourseDetails: { id: 'student.screen.loading.course.details', defaultMessage: 'Loading course details...' },
    partNumber: { id: 'student.screen.part.number', defaultMessage: 'Part {number}' },

    // TopicDetailView
    loadingLessons: { id: 'student.screen.loading.lessons', defaultMessage: 'Loading lessons...' },
    lessons: { id: 'student.screen.lessons', defaultMessage: 'Lessons' },

    // TopicCard / LessonCard fallbacks
    topicFallback: { id: 'student.screen.topic.fallback', defaultMessage: 'Topic' },
    lessonFallback: { id: 'student.screen.lesson.fallback', defaultMessage: 'Lesson' },

    // StudentSidebar - Account section
    account: { id: 'student.screen.account', defaultMessage: 'Account' },
    loginOnAnotherDevice: { id: 'student.screen.login.another.device', defaultMessage: 'Log in on another device' },
    setPassword: { id: 'student.screen.set.password', defaultMessage: 'Set password' },

    // StudentAccessCodeDialog
    accessCodeInstructions: {
        id: 'student.screen.access.code.instructions',
        defaultMessage: 'Use this code to log in on another device. Enter it on the login screen or scan the QR code.',
    },
    accessCodeExpiry: { id: 'student.screen.access.code.expiry', defaultMessage: 'Valid for 2 hours' },
    accessCodeQrHint: {
        id: 'student.screen.access.code.qr.hint',
        defaultMessage: 'Scan this QR code with the camera on your other device',
    },
    copyLoginLink: { id: 'student.screen.copy.login.link', defaultMessage: 'Copy login link' },

    // StudentSetPasswordDialog
    setPasswordDescription: {
        id: 'student.screen.set.password.description',
        defaultMessage: 'Set a password so you can log in with your email and password on any device.',
    },
    newPassword: { id: 'student.screen.new.password', defaultMessage: 'New password' },
    confirmPassword: { id: 'student.screen.confirm.password', defaultMessage: 'Confirm password' },
    passwordTooShort: { id: 'student.screen.password.too.short', defaultMessage: 'Password must be at least 6 characters' },
    passwordsDoNotMatch: { id: 'student.screen.passwords.do.not.match', defaultMessage: 'Passwords do not match' },
    passwordSetSuccess: { id: 'student.screen.password.set.success', defaultMessage: 'Password has been set successfully!' },
    saving: { id: 'student.screen.saving', defaultMessage: 'Saving...' },

    // Privacy terms and conditions
    termsAcceptLabel: {
        id: 'student.screen.terms.accept.label',
        defaultMessage: 'I accept the',
    },
    termsAcceptLinkText: {
        id: 'student.screen.terms.accept.link.text',
        defaultMessage: 'privacy terms and conditions',
    },
    termsGateHeading: {
        id: 'student.screen.terms.gate.heading',
        defaultMessage: 'To use Capeesh, please review and accept our privacy terms and conditions',
    },
    termsGateBody: {
        id: 'student.screen.terms.gate.body',
        defaultMessage: 'You only need to do this once. You can read the full document before you accept.',
    },
    termsRequiredHint: {
        id: 'student.screen.terms.required.hint',
        defaultMessage: 'Please accept the privacy terms and conditions to continue',
    },
    termsAcceptAndContinue: {
        id: 'student.screen.terms.accept.and.continue',
        defaultMessage: 'Accept and continue',
    },
    termsAcceptFailed: {
        id: 'student.screen.terms.accept.failed',
        defaultMessage: 'Something went wrong. Please try again.',
    },
    termsLogOut: {
        id: 'student.screen.terms.log.out',
        defaultMessage: 'Log out',
    },
})
